import { iHolidayQuoteItineraryBlock } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function partitionItineraryForTripMode(
  itinerary: iHolidayQuoteItineraryBlock[]
) {
  const hotels: iHolidayQuoteItineraryBlock[] = [];
  const flights: iHolidayQuoteItineraryBlock[] = [];
  const other: iHolidayQuoteItineraryBlock[] = [];

  for (const block of itinerary) {
    if (block.type === "hotel") {
      hotels.push(block);
    } else if (block.type === "flight") {
      flights.push(block);
    } else {
      other.push(block);
    }
  }

  return { hotels, flights, other };
}

export function isTripMode(mode?: string | null): boolean {
  return mode === "trip";
}
